module.exports = __webpack_public_path__ + "img/business.7cc62f20.png";